/**
 * Multiselect de bases legais:
 * - lista vazia = todas as bases legais (sem restrição)
 * - lista parcial = filtra pelos códigos selecionados (id da base legal ou SEM_BASE_LEGAL)
 *
 * "Sem base legal" não é uma base legal, é a ausência de uma — por isso não entra na lista
 * de opções marcáveis (`opcoesBaseLegal`); só é alcançável pelo atalho "Sem base legal".
 */
import { SEM_BASE_LEGAL } from "./filtrarLinhasEsocial.util";

export function opcoesBaseLegal(basesLegais) {
  return (basesLegais || []).map((b) => ({ codigo: String(b.id), label: b.descricao }));
}

export function isBaseLegalMarcada(codigo, selecionadas) {
  return (selecionadas || []).includes(codigo);
}

export function alternarBaseLegalSelecao(codigo, selecionadas) {
  const lista = selecionadas || [];
  if (lista.includes(codigo)) {
    return lista.filter((c) => c !== codigo);
  }
  return [...lista, codigo];
}

/** Marca todas as bases legais específicas (equivalente a "com base legal"). */
export function acaoSelecionarTodasBaseLegal(opcoes) {
  return (opcoes || []).map((o) => o.codigo);
}

/** Marca somente "sem base legal". */
export function acaoSelecionarSemBaseLegal() {
  return [SEM_BASE_LEGAL];
}

/** Desmarca todas as bases legais — lista vazia = sem restrição, mostra tudo. */
export function acaoLimparBaseLegal() {
  return [];
}

export function textoTriggerBaseLegal(selecionadas, opcoes) {
  const total = opcoes?.length ?? 0;
  const sel = selecionadas || [];
  const semMarcado = sel.includes(SEM_BASE_LEGAL);
  const qtdReais = semMarcado ? sel.length - 1 : sel.length;
  if (sel.length === 0) return `Todas as bases legais (${total})`;
  if (semMarcado && qtdReais === 0) return "Sem base legal";
  if (!semMarcado && qtdReais === total) return `Com base legal (${total})`;
  return semMarcado
    ? `Sem base legal + ${qtdReais} de ${total} base(s) legal(is)`
    : `${qtdReais} de ${total} base(s) legal(is)`;
}
